import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import VectorSource from 'ol/source/Vector';
import { Icon, Style, Text, Fill } from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import * as extent from 'ol/extent';

import marker from '../../../images/marker_active.svg';
import { useLocation } from 'react-router-dom';

const iconStyle = new Style({
  image: new Icon({
    size: [48, 48],
    anchor: [24, 36],
    anchorXUnits: 'pixels',
    anchorYUnits: 'pixels',
    src: marker
  }),
  text: new Text({
      offsetY: -13,
      font: `bold 9px Cerebri Sans`,
      fill: new Fill({ color: '#fff' })
  })
});

function _getLayer(map,id){
  var l = !1,
  d = map.getLayers().getArray(),
  i = d.length - 1;
  while(i>=0){
    if(d[i].get('name') === id){
      l = d[i];
      break;
    }
    i--;
  }
  return l;
}

const LactiveMarkers = () => {
  const location = useLocation();
  const { map, select } = useSelector(s => s.map);
  const {
    allMarkers,
    markersExtent,
    filteredExtent
  } = useSelector(s => s.markers);
  const { studyID, studySite } = useSelector(s => s.studyDetail);

  var zIndex = 0;

  useEffect(()=>{
    const ml = map ? _getLayer(map, 'markers') : false;
    const cl = map ? _getLayer(map, 'cluster-markers') : false;
    const al = map ? _getLayer(map, 'active-markers') : false;
    if(map && al){
      map.removeLayer(al);
    }

    let vectorLayer = null;
    const _studyID = studyID && studyID !== -1
      ? (
          Array.isArray(studyID)
          ? (studyID[0] === -1 ? [] : studyID)
          : [studyID]
        )
      : [];

    if (
      (map && _studyID.length) ||
      (map && studySite)
    ) {
      if (ml) ml.setVisible(false);
      if (cl) cl.setVisible(false);

      const m = [];
      const f = allMarkers;

      let i = f.length - 1;

      if (!studySite) {
        while (i >= 0) {
          const _id = f[i].properties.studyId;
          let j = _id.length - 1;
          let size = !1;
          while (j >= 0) {
            if ( _studyID.includes(_id[j]) ) {
              size++;
            }
            j--;
          }
          if (size) {
            m.push(f[i]);
          }
          i--;
        }

      } else {
        while(i >= 0){
          if ( studySite[0] === f[i].properties.s ) {
            m.push(f[i]);
            break;
          }
          i--;
        }
      }

      const features = new GeoJSON({
        featureProjection: 'EPSG:3857'
      }).readFeatures({
        "type": "FeatureCollection",
        "features": m
      })

      const vectorSource = new VectorSource({ features });

      vectorLayer = new VectorLayer({
        source: vectorSource,
        style: function(f){
          if (studySite) {
            iconStyle
              .getText()
              .setText(`${
                f.getProperties().t > 1
                  ? f.getProperties().t
                  : ''
              }`);
            iconStyle.setZIndex(zIndex++);
          } else {
            const arr = f.getProperties().studyId
            const size = arr.length
            iconStyle.getText().setText(`${size > 1 ? size : ''}`);
          }
          iconStyle.setZIndex(zIndex++);
          return iconStyle;
        },
        name: 'active-markers'
      });
      map.addLayer(vectorLayer);

      const view = map.getView();

      if (vectorSource) {
        const total = m.length
        
        const ext = {
          center: extent.getCenter(vectorSource.getExtent()),
          zoom: total > 1
            ? (
                view.getZoomForResolution(
                  view.getResolutionForExtent(vectorSource.getExtent())
                ) -0.25
              )
            : 12
        }
        map.getView().animate({
          ...ext,
          duration: total > 1 ? 1500 : 2000
        });

      }

    }

    if ((map && !studyID && !studySite)) {
      if (ml) ml.setVisible(true);
      if (cl) cl.setVisible(true);
      if (al) {
        map.removeLayer(al);
      }
      if (select) {
        map.removeInteraction(select);
      }
      if (filteredExtent) {
        map.getView().animate({
          center: filteredExtent ? filteredExtent.center : markersExtent.center,
          zoom: filteredExtent ? filteredExtent.zoom : markersExtent.zoom,
          duration: 1500
        });
      }
    }

    return () => {
      if (al) {
        map.removeLayer(al);
        if (select) {
          map.removeInteraction(select);
        }
      }
    }

  }, [studyID, studySite, location.pathname]);

  return null;
}

export default LactiveMarkers;
